import {
  GET_ALL_MEDICAL_HISTORY,
  GET_ALL_MEDICAL_HISTORY_SUCCESS,
  GET_MEDICAL_DRAFT,
  GET_MEDICAL_DRAFT_SUCCESS,
  GET_MEDICAL_DRAFT_FAILURE,
} from '../storeTypes';

const INIT_STATE = {
  loader: false,
  medicalHistory: [],
  medicalDraft: null,
  medicalDraftLoader: false,
};

function MedicalHistoryReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case GET_ALL_MEDICAL_HISTORY: {
      return {
        ...state,
        medicalHistory: [],
        loader: true,
      };
    }

    case GET_ALL_MEDICAL_HISTORY_SUCCESS: {
      return {
        ...state,
        loader: false,
        medicalHistory: action.payload,
      };
    }

    case GET_MEDICAL_DRAFT: {
      return {
        ...state,
        medicalDraft: null,
        medicalDraftLoader: true,
      };
    }

    case GET_MEDICAL_DRAFT_SUCCESS: {
      return {
        ...state,
        medicalDraftLoader: false,
        medicalDraft: action.payload,
      };
    }

    case GET_MEDICAL_DRAFT_FAILURE: {
      return {
        ...state,
        medicalDraftLoader: false,
      };
    }

    default: {
      return state;
    }
  }
}

export default MedicalHistoryReducer;
